import { Component, Input } from '@angular/core';

@Component({
  selector: 'acan-empty-state',
  templateUrl: './acan-empty-state.component.html',
  styleUrls: ['./acan-empty-state.component.scss'],
  standalone: false,
})
export class AcanEmptyStateComponent {
  @Input() message = 'No records found';
  @Input() icon?: string;
}
